import React from 'react'
import { Typography, Box, TextField } from '@octanner/prism-core'
import CelebrationTimelineView from './CelebrationTimelineView'
import { DateTime } from 'luxon'
import { GetCelebrationByIdentityResponse } from '../hooks/useGetCelebrationByIdentity'

export type ExistingCelebrationInfoProps = {
  celebration: GetCelebrationByIdentityResponse['ybCelebrationByIdentity']
}
const ExistingCelebrationInfo: React.FC<ExistingCelebrationInfoProps> = ({
  celebration,
}) => {
  const formatDateString = (dateStr: string): string => {
    return DateTime.fromISO(dateStr, { zone: 'local' }).toFormat('dd LLL yyyy')
  }

  return (
    <Box data-testid="existing-celebration-info">
      <Typography variant="h3" data-testid="celebration-details-header">
        Celebration details
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          mt: 2,
        }}
      >
        <TextField
          id="read-only-anniversary-year"
          label="Anniversary year"
          defaultValue={`${celebration.level.rank} year`}
          InputProps={{
            readOnly: true,
            // @ts-ignore this is a real property of inputProps
            'data-testid': 'anniversary-year-field',
          }}
          sx={{ width: '466px', height: '56px' }}
        />
        <TextField
          id="read-only-celebration-date"
          label="Celebration date"
          defaultValue={formatDateString(celebration.createdOn)}
          InputProps={{
            readOnly: true,
            // @ts-ignore this is a real property of inputProps
            'data-testid': 'celebration-date-field',
          }}
          sx={{ width: '466px', height: '56px' }}
        />
      </Box>
      <CelebrationTimelineView
        celebrationTimeline={celebration.celebrationTimeline}
        data-testid="action-schedule-timeline"
        celebrationCreationDate={celebration.createdOn}
        hasPrivateCelebrations={
          celebration.identity.yearbookPreferences.hasPrivateCelebrations
        }
      />
    </Box>
  )
}
export default ExistingCelebrationInfo
